import script from "./AmenitiesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AmenitiesSection.vue?vue&type=script&setup=true&lang=ts"

import "./AmenitiesSection.vue?vue&type=style&index=0&id=656d63d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656d63d9"]])

export default __exports__